import { createReducer } from 'redux-act';
import {
  SCHEDULE_FETCH_DATA_INIT,
  SCHEDULE_FETCH_DATA_SUCCESS,
  SCHEDULE_FETCH_DATA_FAIL,
  SCHEDULE_DELETE_INIT,
  SCHEDULE_DELETE_SUCCESS,
  SCHEDULE_DELETE_FAIL,
  SCHEDULE_CREATE_INIT,
  SCHEDULE_CREATE_SUCCESS,
  SCHEDULE_CREATE_FAIL,
  SCHEDULE_MODIFY_INIT,
  SCHEDULE_MODIFY_SUCCESS,
  SCHEDULE_MODIFY_FAIL,
  SCHEDULE_CLEAN_UP,
  SCHEDULE_CLEAR_DATA_LOGOUT,
  SET_SCHEDULE,
} from 'state/actions/schedule';

const initialState = {
  list: [],
  schedule: {
    _id: '',
    name: '',
    description: '',
    screenIds: [],
    startDate: null,
    endDate: null,
    scheduleType: 'allDay',
  },
  loading: false,
  error: null,
  success: false,
  deleted: false,
  updated: false,
};

export const scheduleReducer = createReducer(
  {
    [SCHEDULE_FETCH_DATA_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [SCHEDULE_FETCH_DATA_SUCCESS]: (state, payload) => ({
      ...state,
      list: payload.list || [],
      schedule: payload.schedule || initialState.schedule,
      loading: false,
      error: null,
    }),
    [SCHEDULE_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [SCHEDULE_DELETE_INIT]: (state) => ({ ...state, loading: true }),
    [SCHEDULE_DELETE_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.filter((el) => el._id !== payload.id),
      loading: false,
      error: null,
      deleted: true,
    }),
    [SCHEDULE_DELETE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [SCHEDULE_CREATE_INIT]: (state) => ({ ...state, loading: true }),
    [SCHEDULE_CREATE_SUCCESS]: (state) => ({
      ...state,
      loading: false,
      error: null,
      success: true,
      updated: true,
    }),
    [SCHEDULE_CREATE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [SCHEDULE_MODIFY_INIT]: (state) => ({ ...state, loading: true }),
    [SCHEDULE_MODIFY_SUCCESS]: (state) => ({
      ...state,
      loading: false,
      error: null,
      success: true,
      updated: true,
    }),
    [SCHEDULE_MODIFY_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [SCHEDULE_CLEAN_UP]: (state) => ({
      ...state,
      loading: false,
      error: null,
      success: false,
      deleted: false,
      updated: false,
    }),
    [SCHEDULE_CLEAR_DATA_LOGOUT]: () => ({ ...initialState }),
    [SET_SCHEDULE]: (state, payload) => ({
      ...state,
      schedule: payload.data,
    }),
  },
  initialState
);